import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import PageContainer from '@/components/ui/containers/PageContainer'

import ApiKeysTable from './containers/ApiKeysTable'

export function ApiKeysPage() {
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <PageContainer>
      <Stack spacing={4}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h2">{t('page.apiKeys.title')}</Typography>
          <Stack direction="row">
            <Button component={Link} to={`${location.pathname}/create`} variant="contained">
              {t('common:button.create.label')}
            </Button>
          </Stack>
        </Stack>
        <ApiKeysTable />
      </Stack>
    </PageContainer>
  )
}

export default ApiKeysPage
